import React from 'react';
import { Star } from 'lucide-react';
interface StarRowProps {
  rating: number;
  className?: string;
  size?: string;
}
export function StarRow({
  rating,
  className = '',
  size = 'h-3.5 w-3.5'
}: StarRowProps) {
  return <span className={`inline-flex gap-0.5 text-bone ${className}`} role="img" aria-label={`${rating} out of 5 stars`} data-id="element-317" data-mp="ld67utlsnpd4">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`${size} ${i < Math.round(rating) ? 'fill-current' : 'text-gunmetal'}`} aria-hidden="true" data-id="element-318" data-mp="3ow7u0m3nwxco" data-mpi={i} />)}
    </span>;
}